<template>
  <div class="detailClient detail-group">
    <div class="name">
      <span class="countName">{{ formGroup.clientName }}</span>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <el-button
          type="primary"
          size="small"
          class="editCount"
          v-show="!isEdit"
          @click="editCount"
        >
          编辑
        </el-button>
        <el-form
            :model="formGroup"
            :rules="rules"
            ref="formGroup"
            label-width="100px"
          >
            <el-form-item label="组ID" prop="groupId">
              <el-input
                v-model.trim="formGroup.groupId"
                :maxlength="32"
                disabled
                placeholder="请输入组ID"
              ></el-input>
            </el-form-item>
            <el-form-item label="组名称" prop="name">
              <el-input
                v-model.trim="formGroup.name"
                :maxlength="32"
                :disabled="!isEdit"
                placeholder="请输入组名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="组管理员" prop="groupAdmin">
              <el-input
                v-model.trim="formGroup.groupAdmin"
                :maxlength="32"
                :disabled="!isEdit"
                placeholder="请输入组管理员"
              ></el-input>
            </el-form-item>
          </el-form>

        <el-form label-width="100px">
          <el-form-item>
            <div class="footer" v-show="isEdit">
              <el-button type="primary" @click="putGroupInfo">确 定</el-button>
              <el-button @click="handleCancel">取 消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="成员信息" name="second">
        <div class="btns">
          <div>
            <!-- <el-button
              type="primary"
              size="small"
              class="addCount"
              @click="setRole"
            >
              添加
            </el-button> -->
          </div>
          <div class="searchBox">
            <el-input
              v-model="searchValue"
              placeholder="支持搜索账户名/邮箱"
              @keyup.enter.native="getGroupUser(true)"
            ></el-input>
            <span class="iconBox" @click="getGroupUser(true)">
              <i class="icon icon-search"></i>
            </span>
          </div>
        </div>
        <el-table :data="tableData" tooltip-effect="light" style="width: 100%">
          <el-table-column
            label="账户名称"
            prop="accountname"
            width="220px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="姓名"
            prop="username"
            width="260px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="电子邮箱"
            prop="email"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="手机号码"
            prop="telephone"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next"
          :page-size="memberPage.pageSize"
          :current-page.sync="memberPage.pageNum"
          :total="memberPage.total"
          @current-change="pageChange"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="授权信息" name="third">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>IDaaS支持基于组授权，组内所有成员将继承组的授权信息。</p>
          </div>
        </div>
        <AuthClientRoles
          ref="AuthClientRoles"
          :tableDataClient="tableDataClient"
          :tableDataAllClient="tableDataAllClient"
          modules="account"
          @postDepartClients="groupClients"
          @putDepAuthCliRoles="groupAuthCliRoles"
          :showTips="false"
        ></AuthClientRoles>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="删除角色" width="500px" :visible.sync="dialogRemoveRole">
      <div class="deleteText">确认删除该角色吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemoveRole">确 定</el-button>
        <el-button @click="dialogRemoveRole = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import APIS from "@/apis/groupManage.js"
import { validateUrl, validateRedirectUrl } from "@/common/utils.js"
import AuthClientRoles from "@/components/department/AuthClientRole.vue"
export default {
  components: {
    AuthClientRoles
  },
  data() {
    const checkRoleFlag = (rule, value, callback) => {
      let pattern = /^[0-9a-zA-Z-]{1,32}$/
      value = value.trim()
      if (value === "") {
        callback(new Error("请输入角色标识"))
      } else if (!pattern.test(value)) {
        callback(new Error("支持英文、数字、中划线(-)"))
      } else {
        callback()
      }
    }
    return {
      formGroup: {
        groupId: "",
        groupAdmin: "",
        name: "",
        description: ""
      },
      formGroupOld: {}, // 缓存当前的参数
      tableData: [],//成员列表
      memberPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      grantPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      department: [],
      tableDataClient: [], // 账户已授权的应用
      tableDataAllClient: [], // 所有可授权的应用
      searchValue: null,
      dialogSetRoleVisible: false,
      dialogRemoveRole: false,
      breadcrumb: [
        {
          label: "资源组",
          url: "/groupManage"
        },
        {
          label: "资源组详情"
        }
      ],
      activeName: "first",
      rules: {
        rootUrl: [
          { required: true, message: "请输入根URL", trigger: "blur" },
          { validator: validateUrl, trigger: "blur" }
        ],
        clientName: [
          { required: true, message: "请输入应用名称", trigger: "blur" }
        ],
        redirectUrl: [
          { required: true, message: "请输入重定向URI", trigger: "blur" },
          { validator: validateRedirectUrl, trigger: "blur" }
        ],
        groupId: [{ required: true, message: "请输入组ID", trigger: "blur" }],
        name: [{ required: true, message: "请输入组名称", trigger: "blur" }]
      },
      ruleFormRole: {
        roleFlag: "",
        roleName: "",
        roleDesc: ""
      },
      rulesRole: {
        roleFlag: [
          { required: true, validator: checkRoleFlag, trigger: "blur" }
        ],
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" }
        ]
      },
      isEdit: false,
      realmName: this.$realm,
      groupID: "",
      isGrant: true,
      currentRole: null
    }
  },
  computed: {
    roleTitle() {
      return this.isEditRole ? "授权应用角色" : "授权应用"
    }
  },
  created() {
    this.groupID = this.$route.query.groupID
  },
  mounted() {
    if (this.groupID) {
      this.getRealmsGroupInfo()
      this.getGroupUser()
      this.getGroupHasGrantApps()
    }

  },
  methods: {
    // 获取组成员列表
    async getGroupUser(type) {
      if(type) {
        this.memberPage.pageNum = 1
      }
      let params = {
        key: this.searchValue,
        pageNum: this.memberPage.pageNum,
        pageSize: this.memberPage.pageSize
      }
      let { status, data } = await APIS.getGroupUser(
        this.realmName,
        this.groupID,
        { params }
      )
      this.memberPage.total = 0
      this.tableData = []
      if (status === 0) {
        this.memberPage.total = data.totalCount || 0
        this.tableData = data.data
      }
    },
    // 获取组已授权的应用列表
    async getGroupHasGrantApps() {
      let { status, data } = await APIS.getGroupRoles(
        this.realmName,
        this.groupID
      )
      this.tableDataClient = []
      this.tableDataAllClient = []
      if (status === 0 && data) {
        data.forEach(item => {
          let obj = {
            id: item.id,
            clientId: item.clientId,
            clientName: item.clientName,
            role: item.roles,
            authMark: item.authMark
          }
          this.tableDataAllClient.push(obj)
          if (item.authMark) {
            this.tableDataClient.push(obj)
          }
        })
      }
    },
    // 翻页
    pageChange(str) {
      if(str === 'grant') {
        this.getGroupHasGrantApps()
      } else {
        this.getGroupUser()
      }
    },
    // 给组授权应用
    groupClients({ addCIds, remCIds }) {
      this.putGroupClients({ addCIds, remCIds })
    },
    // 给组应用授权角色
    groupAuthCliRoles({ clientId, addRoleMarks, remRoleMarks }) {
      this.putGroupAuthCliRoles({ clientId, addRoleMarks, remRoleMarks })
    },
    // 给组授权应用
    async putGroupClients({ addCIds, remCIds }) {
      let params = {
        addCIds,
        remCIds
      }
      let { status } = await APIS.putGroupmentAuthClients(
        this.realmName,
        this.groupID,
        { data: params }
      )
      if (status === 0) {
        this.$refs.AuthClientRoles.dialogAuthClient = false
        this.getGroupHasGrantApps()
      }
    },
    // 给账户应用授权角色
    async putGroupAuthCliRoles({ clientId, addRoleMarks, remRoleMarks }) {
      let params = {
        addRoleMarks,
        remRoleMarks
      }
      let { status } = await APIS.putGroupAuthCliRoles(
        this.realmName,
        this.groupID,
        clientId,
        { data: params }
      )
      if (status === 0) {
        this.$refs.AuthClientRoles.dialogSetRoleVisible = false
        this.getGroupHasGrantApps()
      }
    },
    // 获取组信息详情
    async getRealmsGroupInfo() {
      let { status, data } = await APIS.getGroupInfo(
        this.realmName,
        this.groupID
      )
      if (status === 0) {
        this.formGroup.groupID = data && data.id
        this.formGroup.name = data && data.name
        this.formGroup.groupId = data && data.groupId
        this.formGroup.groupAdmin = data && data.groupAdmin
        this.formGroup.description = data && data.description
        this.formGroupOld = Object.assign({}, this.formGroup)
      }
    },
    // 更新组信息
    putGroupInfo() {
      let params = this.formGroup
      this.$refs["formGroup"].validate(async valid => {
            if(!valid) return
            if(JSON.stringify(this.formGroupOld) !== JSON.stringify(this.formGroup)) {
              let { status } = await APIS.putGroupInfo(this.realmName, this.groupID, {
              data: params
              })
              if (status === 0) {
                this.getRealmsGroupInfo()
              } else {
                this.formGroup = JSON.parse(JSON.stringify(this.formGroupOld))
              }
            }
            this.isEdit = false
      });
    },
    // 编辑账户按钮
    editCount() {
      this.isEdit = true
    },
    handleClick() {
      this.isEdit = false
      this.$refs["formGroup"].resetFields()
      this.formGroup = Object.assign({}, this.formGroupOld)
      this.getGroupUser()
      this.$forceUpdate()
    },
    handleCancel() {
      this.isEdit = false
      this.$refs["formGroup"].resetFields()
      this.formGroup = Object.assign({}, this.formGroupOld)
    },
    // 打开授权应用角色弹窗
    handleGrantEdit(id) {
      this.currentRole = this.tableData.find((item) => item.id === id)
      if (!this.currentRole) {
        return false
      }
      this.isGrant = false
      this.dialogSetRoleVisible = true
      this.$nextTick(() => {
        this.initFormRole()
        this.ruleFormRole.roleFlag = this.currentRole.roleFlag
        this.ruleFormRole.roleName = this.currentRole.roleName
        this.ruleFormRole.roleDesc = this.currentRole.roleDesc
      })
    },
    // 打开新建角色弹窗
    setGrant() {
      this.isGrant = true
      this.dialogSetRoleVisible = true
      this.$nextTick(() => {
        this.initFormRole()
      })
    },
    // 确认删除角色
    submitRemoveRole() {
      this.deleteRole()
    },
  }
}
</script>

<style lang="scss">
.btns {
  margin: 0 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .searchBox {
    display: inline-flex;
    .iconBox {
      width: 30px;
      background-color: rgba(22, 155, 213, 1);
      flex-shrink: 0;
      text-align: center;
      line-height: 26px;
      cursor: pointer;
    }
  }
}
.authTip {
    display: flex;
    background-color: rgba(0, 112, 204, 0.05);
    font-size: 13px;
    color: #454647;
    padding: 10px;
    line-height: 22px;
    margin-bottom: 15px;
    align-items: center;
    i {
      margin-right: 10px;
      margin-left: 5px;
    }
  }
.detailClient {
  .name {
    margin-bottom: 16px;
  }
  .el-textarea {
    textarea {
      min-height: 80px !important;
      padding: 5px 10px;
    }
    &.redirectUrl {
      textarea {
        min-height: 66px !important;
      }
    }
  }
  .el-form-item__error {
    white-space: nowrap;
  }
  .el-form {
    &.ruleFormRole {
      width: 370px;
    }
    .icon.icon-copy {
      position: absolute;
      top: 14px;
      right: -30px;
      cursor: pointer;
    }
  }
  .el-tabs {
    .el-button.editCount {
      margin-bottom: 15px;
    }
    .el-button.setRole {
      margin-bottom: 20px;
    }
  }
}
</style>
